<template>
  <div class="mobility notranslate">
    <button type="button" class="btn sizeXs btnMy" @click.stop="goMypage">MY</button>
    <ResultLayer
      v-if="resultLayer"
      :locale="locale"
      :lang="lang"
      :isPublic="isPublic"
      :qrOnly="true"
      @cancel="resultLayer = false" />
    <!-- <router-link :to="{ name: 'myMobility' }" class="btn sizeXs btnMy">MY</router-link> -->
    <component v-if="component && origin"
      :is="component"
      :locale="locale"
      :lang="lang"
      :ln="ln"
      :isPublic="isPublic"
      :responsive="responsive"
      :origin="origin"
      :disabled="disabled"
      :preset="preset"
      @completeCycle="completeCycle"
      @reload="reload" />
    <div v-if="currentLayer" class="layer">
      <div class="inner">
        <button type="button" class="btnClose" @click.stop="currentLayer = false"><span class="blind">close</span></button>
        <div class="layerTitle toCapitalize">{{locale.mobility_current_exist}}</div>
        <p class="mb15">{{locale.message_mobility_request_result_success_2}}</p>
        <p class="cf mb15">{{locale.message_mobility_request_result_success_3}}</p>
        <div v-if="isPublic && qrCode" class="qrInfo">
          <p>{{locale.mobility_my_qrcode}}</p>
          <div class="qrBg">
            <div v-if="qrCode === 'fail'" class="noQr"><img src="@/assets/img/img_qr_fail.png" alt=""></div>
          <vue-qrcode
            v-else
            :value="qrCode"
            :scale="6" />
          </div>
          <div v-if="qrCode === 'fail'" class="failMessage">{{locale.qr_create_fail}}<br>{{locale.refresh_retry}}</div>
        </div>
        <div v-if="!isPublic" class="btns">
          <!-- <button type="button" class="btn btnWhite toCapitalize" @click.stop="cancel">{{locale.close}}</button> -->
          <router-link
            :to="{ name: 'myMobility' }"
            class="btn btnFull toCapitalize">
            {{locale.mobility_my}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import ResultLayer from '@/components/Maps/ResultLayer'

export default {
  name: 'Mobility',
  props: [
    'locale',
    'lang',
    'ln',
    'isPublic',
    'responsive'
  ],
  components: {
    VueQrcode,
    ResultLayer
  },
  computed: {
    siteinfo () {
      return this.$store.state.authentication
    }
  },
  created () {
    this.track()
    this.init()
  },
  mounted () {
    this.$nextTick(() => {
      this.initMount()
    })
  },
  data () {
    return {
      map: 'naver',
      resultLayer: false,
      current: null,
      currentLayer: false,
      qrCode: null,
      disabled: false,
      origin: null,
      preset: null
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'mobility'
      })
    },
    init () {
      const map = this.map
      const mapComponent = map ? map.replace(/\b\w/g, l => l.toUpperCase()) : null
      if (map) {
        // this.component = () => import(`@/components/Maps/${mapComponent}.vue`)
        this.component = () => import(`@/components/Maps/Naver.vue`)
      } else {
        this.component = null
      }
      this.getMyMobility()
      // this.$store.dispatch('guest/getMobilityPreset').then((res) => {
      //   if (res && res.activePreset && res.preset) {
      //     this.preset = res.preset
      //   }
      // })
    },
    initMount () {
      const siteinfo = this.siteinfo
      const win = window.location
      let params = publicToOta(win.search)
      let url = ''
      // 공용디바이스 사용자는 개인링크로 변환 params
      this.getOrigin()
      function publicToOta (queryString) {
        const params = {}
        queryString.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
          params[key] = value
        })
        params.frame = false
        return params
      }
      if (this.isPublic) {
        delete params.public
        params.k = siteinfo.k
        params = Object.entries(params).map(e => e.join('=')).join('&')
        url = `${win.origin}${win.pathname}?${params}#/${this.lang}/mobility/my`
        this.$store.dispatch('util/getShortUrl', {
          url: url,
          days: 1
        }).then((res) => {
          if (res) {
            this.qrCode = res
          } else {
            this.qrCode = 'fail'
          }
        })
      }
    },
    async getOrigin () {
      this.$store.commit('loading', true)
      return this.$store.dispatch('guest/getMobilityOrigin').then((res) => {
        if (res) {
          if (res.geo) {
            const origin = res.geo
            this.origin = {
              lat: origin.lat,
              lng: origin.lng,
              startName: res.siteName
            }
          } else {
            if (res.message && res.message.includes('not support')) {
              alert(this.locale.alert_not_support)
            } else {
              alert(this.locale.alert_system_error)
            }
            this.$router.push('/')
          }
          this.$store.commit('loading', false)
        } else {
          alert(this.locale.alert_system_error)
          this.$router.push('/')
          this.$store.commit('loading', false)
        }
        return true
      })
    },
    getMyMobility () {
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/getMobilityList').then((res) => {
        this.$store.commit('loading', false)
        this.ready = true
        if (res && res.items && res.items.length > 0) {
          this.current = true
          this.currentLayer = true
          this.disabled = true
        } else {
          this.current = null
          this.currentLayer = false
          this.disabled = false
        }
      })
    },
    goMypage () {
      if (this.isPublic) {
        this.resultLayer = true
      } else {
        this.$router.push({
          name: 'myMobility'
        })
      }
    },
    completeCycle () {
      this.disabled = true
    },
    reload () {
      this.init()
      this.initMount()
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  & > .inner {
    max-width: 480px;
  }
}
.qrInfo {
  margin-top: 30px;
  text-align: center;
  font-size: 20px;
}
.qrBg {
  height: 200px;
  margin-bottom: 15px;
  background: url('~@/assets/img/img_qr_loading.png') 50% 50% / contain no-repeat;
  img {
    max-height: 100%;
  }
}
.noQr {
  height: 100%;
  background-color: $color-white;
}
.failMessage {
  font-size: 14px;
  color: $color-red;
}
.cf {
  font-size: 14px;
  color: $color-grey;
}
@media screen and (min-width: 768px) {
  .layer {
    & > .inner {
      padding: 30px;
    }
  }
}
</style>
